<template>
	<fragment>
		<common-header
			subname="게시판관리"
			name="게시물 목록"
			v-bind:searchbox="true"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:initKeyword="keyword"
			@keywordChanged="searchByKeyword"
		></common-header>

		<section ref="container" class="container">
			<common-side-menu :menus="sideMenus" :btnList="sideButtons"></common-side-menu>

			<div class="container-fiuld clearfix" v-if="selectedBoard">
				
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						{{selectedBoard.boardName}} 
						<img src="images/view-off.png" alt="노출안함" v-if="selectedBoard && selectedBoard.hideEnable"/>
						<!-- <img src="images/view-on.png" alt="노출상태" v-else/> -->
						<a class="modify" @click="routerBoardModify"></a>
						<a class="del" @click="deleteBoard" v-if="boardDelete && trashBoardId !== parseInt($route.params.boardId)"></a>
					</div>
				</div>
				
				<div class="title-box clearfix">
					링크: {{link}}
					<a class="btn-sm btn-blue round" :href="moveLink" target="_blank" title="새창열림">링크이동하기</a>
				</div>
				<div class="btn-group pull-left clearfix">
					<div class="select pull-right m-r-5 m-b-15" v-if="articleDelete && trashBoardId !== parseInt($route.params.boardId)">
						<a class="btn btn-red round" @click="trashArticleList">
							<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="17" height="20" viewBox="0 0 17 20">
								<path class="recycle"
									d="M510.213,1255.71h1.574v8.16h-1.574v-8.16Zm3.148,0h1.574v8.16h-1.574v-8.16Zm-6.3,0h1.574v8.16h-1.574v-8.16Zm10.074-5.86h-2.4v-0.51a2.353,2.353,0,0,0-2.361-2.34h-2.755a2.354,2.354,0,0,0-2.361,2.34v0.51h-2.4a2.353,2.353,0,0,0-2.361,2.34v1.96h1.574v10.51a2.353,2.353,0,0,0,2.361,2.34h9.13a2.353,2.353,0,0,0,2.361-2.34v-10.51H519.5v-1.96A2.353,2.353,0,0,0,517.139,1249.85Zm-8.3-.51a0.784,0.784,0,0,1,.787-0.78h2.755a0.784,0.784,0,0,1,.787.78v0.51h-4.329v-0.51Zm7.517,15.32a0.784,0.784,0,0,1-.787.78h-9.13a0.784,0.784,0,0,1-.787-0.78v-10.51h10.7v10.51Zm1.574-12.07H504.074v-0.4a0.784,0.784,0,0,1,.787-0.78h12.278a0.784,0.784,0,0,1,.787.78v0.4Z"
									transform="translate(-502.5 -1247)"></path>
							</svg> 일괄 휴지통으로 이동
						</a>
					</div>
					<div class="select pull-right m-r-5 m-b-15" v-else-if="articleDelete && trashBoardId === parseInt($route.params.boardId)">
						<a class="btn btn-red round" @click="deleteArticleList">
							<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="17" height="20" viewBox="0 0 17 20">
								<path class="recycle"
									d="M510.213,1255.71h1.574v8.16h-1.574v-8.16Zm3.148,0h1.574v8.16h-1.574v-8.16Zm-6.3,0h1.574v8.16h-1.574v-8.16Zm10.074-5.86h-2.4v-0.51a2.353,2.353,0,0,0-2.361-2.34h-2.755a2.354,2.354,0,0,0-2.361,2.34v0.51h-2.4a2.353,2.353,0,0,0-2.361,2.34v1.96h1.574v10.51a2.353,2.353,0,0,0,2.361,2.34h9.13a2.353,2.353,0,0,0,2.361-2.34v-10.51H519.5v-1.96A2.353,2.353,0,0,0,517.139,1249.85Zm-8.3-.51a0.784,0.784,0,0,1,.787-0.78h2.755a0.784,0.784,0,0,1,.787.78v0.51h-4.329v-0.51Zm7.517,15.32a0.784,0.784,0,0,1-.787.78h-9.13a0.784,0.784,0,0,1-.787-0.78v-10.51h10.7v10.51Zm1.574-12.07H504.074v-0.4a0.784,0.784,0,0,1,.787-0.78h12.278a0.784,0.784,0,0,1,.787.78v0.4Z"
									transform="translate(-502.5 -1247)"></path>
							</svg> 일괄 삭제
						</a>
					</div>
				</div>
				<div class="btn-group pull-right p-10 p-r-0">
					<div class="select pull-left m-r-5">
						날짜 범위: 
					</div>
					<div class="select pull-left m-r-5">
						<VueCtkDateTimePicker
							:no-value-to-custom-elem="true"
							:only-date="true"
							:format="'YYYY-MM-DD'"
							v-model="startDate"
						>
							<input class="form-control full-width" type="text" :value="startDate"/>
						</VueCtkDateTimePicker>
					</div>
					<div class="select pull-left m-r-5">
						~
					</div>
					<div class="select pull-left m-r-5">
						<VueCtkDateTimePicker
							:no-value-to-custom-elem="true"
							:only-date="true"
							:format="'YYYY-MM-DD'"
							v-model="endDate"
						>
							<input class="form-control full-width" type="text" :value="endDate"/>
						</VueCtkDateTimePicker>
					</div>
					<div class="select pull-left m-r-5">
						<a class="btn round pull-left" @click="excelDownload">
							<img class="v-mid m-r-5" src="images/x.png" alt=""> 게시물 통계 다운로드
						</a>
					</div>
					<!-- <div class="select pull-left m-r-5">
						<a class="btn round pull-left" @click="excelDownload">
							<img class="v-mid m-r-5" src="images/x.png" alt=""> 게시물 + 첨부파일 통계 다운로드
						</a>
					</div> -->
				</div>

				<div class="btn-group-box clearfix">
					<table class="table2 table-hover text-center">
						<thead>
							<tr class="bg-lightgray">
								<th class="w20">
									<input id="table-allcheck" class="checkbox" type="checkbox" :checked="allSelected" @change="selectAll">
									<label for="table-allcheck">체크버튼</label>
								</th>
								<th class="w60">#</th>
								<th class="w80">분류</th>
								<th class="w200">제목</th>
								<th class="w160">작성자(아이디)</th>
								<th class="w100">작성일</th>
								<th class="w40">조회</th>
								<th class="w140">관리</th>
							</tr>
						</thead>
						<tbody v-for="article in articleList" :key="`article-id-${article.articleId}`">
							<tr class="margin">
								<td colspan="7"></td>
							</tr>
							<tr v-bind:style="{'background-color': article.backgroundColor }">
								<td>
									<input :id="`article-check-${article.articleId}`" class="checkbox" type="checkbox" v-model="article.selected">
									<label :for="`article-check-${article.articleId}`">체크버튼</label>
								</td>
								<td>
									{{!article.noticeEnable && totalCount - offset - article.num || "공지"}}
								<td>
									{{article.articleCategoryId?article.articleCategoryNm:"미분류"}}
								</td>
								<td v-bind:style="{'text-align': 'left', 'color': article.nameColor }">
									<a @click="routerArticle(article)">
										<span v-for="(i, idx) in new Array(article.depth || 0)" :key="'space-for-'+article.articleId+'-'+idx" class="m-r-10"></span>
										<span v-if="article.depth"><img src="images/re.png"> [답글] </span> 
										<span class="m-r-5">{{article.title}}</span>  
									</a>
									<a v-if="article.depth" @click="routerMainArticle(article)">
										<span class="m-r-5">[원문 바로가기]</span> 
										<img src="images/ic_file2.png" v-if="article.articleFileMappingList.length"/>
									</a>
								</td>
								<td>
									{{article.mber && article.mber.mberName || article.name}}<br>{{article.mberId && `(${article.mberId})`|| ""}}
								</td>
								<td>
									{{article.regDate}}
								</td>
								<td>
									{{article.lookupCount}}
								</td>
								<td>
									<a class="move m-r-5 handle" @click="showModalBoardManager('move', article)">게시판 이동</a>
									<a class="copy m-r-5 handle" @click="showModalBoardManager('copy', article)">복사</a>
									<a class="del m-r-5 handle" @click="showModalBoardManager('trash', article)" v-if="articleDelete && trashBoardId !== parseInt($route.params.boardId)">휴지통</a>
									<a class="del m-r-5 handle" @click="deleteArticle(article)" v-if="articleDelete && trashBoardId === parseInt($route.params.boardId)">삭제</a>
								</td>
							</tr>
						</tbody>
					</table>

					<ctrl-pagination :currentPage="offset / pageSize + 1"
						:pageSize="pageSize" :totalCount="totalCount"
						@pageChanged="onPageChanged"></ctrl-pagination>
				</div>
			</div>
		</section>

		<common-footer></common-footer>

		<modal-board-manager :config="modals.ModalBoardManager" :boardList="sideMenus" @close="modals.ModalBoardManager.show=false" @onDone="onDone" @onConfirm="onConfirm"></modal-board-manager>
		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert> 	
		
	</fragment>
</template>

<script>
/**
 * TODO: 게시물 목록 권한 체크해야할 부분
 * 게시판 조회 (사이드 메뉴 리스트)
 * 게시판 작성 (헤더 메뉴)
 * 게시판 수정 (본문)
 * 
 * 게시물 조회 (본문)
 * 게시물 작성 (헤더 메뉴)
 * 게시물 이동 (본문)
 * 게시물 복사 (본문)
 * 게시물 삭제 (본문)
 */
import fnAdjustHeight from "../mixins/fnAdjustHeight.js";
import fnUserList from "../mixins/fnUserList";
import fnScrollable from "../mixins/fnScrollable";
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'
import CtrlPagination from '../components/CtrlPagination.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import ModalBoardManager from '../modals/ModalBoardManager.vue'
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import moment from "moment";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import Axios from 'axios'
import server from '../statics/server'

export default {
	// 컴포넌트 명칭
	name: "ViewBoardList",
	mixins: [fnAdjustHeight, fnUserList, fnScrollable],
	mounted: function() {
		this.getBoardList();
		this.getArticlList();
		this.getAuthInfo().then((auth) => {
			if(auth['관리자 권한']['게시판관리: 게시물 등록'] && auth['관리자 권한']['게시판관리: 게시물 등록']['permission']) {
				this.buttons = [
					...this.buttons, 
					{name: '게시물 작성', fn: () => {
						this.$router.push(`/board/${this.$route.params.boardId}/write`);
					}},
				];
			}

			if(auth['관리자 권한']['게시판관리: 게시판 생성'] && auth['관리자 권한']['게시판관리: 게시판 생성']['permission']) {
				this.buttons = [
					...this.buttons, 
					{name: '게시판 만들기', fn: () => {
						this.$router.push("/board/register");
					}},
				];
			}

			if(auth['관리자 권한']['게시판관리: 게시물 삭제'] && auth['관리자 권한']['게시판관리: 게시물 삭제']['permission']) {
				this.articleDelete = true;
			}
			if(auth['관리자 권한']['게시판관리: 게시판 삭제'] && auth['관리자 권한']['게시판관리: 게시판 삭제']['permission']) {
				this.boardDelete = true;
			}

		});
	},
	// 이 컴포넌트에서 사용할 자식컴포넌트
	components: {
		CommonHeader,
		CommonFooter,
		CommonSideMenu,
		CtrlPagination,
		ModalConfirm,
		ModalAlert,
		ModalBoardManager,
		VueCtkDateTimePicker
	},

	// 이 컴포넌트에서 사용할 내부데이터
	data: function() {
		return {
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
				ModalBoardManager : ModalBoardManager.default()
			},
			// button
			menus: [
				{name: '게시물 목록', link: "/board", selected: true},
			],
			buttons: [],
			sideButtons: [],
			sideMenus: [],
			// static
			trashBoardId: server.trashBoardId || null,
			// auth
			articleDelete: false,
			boardDelete: false,
			// link (user)
			link: "",
			moveLink: "",
			startDate : moment(new Date().setFullYear(new Date().getFullYear(),new Date().getMonth(),1)).format("YYYY-MM-DD"),
			endDate : moment(Date.now()).format("YYYY-MM-DD"),
			// primary data
			selectedBoard: null,
			articleList: [],
			// pageOpt
			keyword: this.$route.query.keyword || "",
			pageSize: parseInt(this.$route.query.pageSize) || 30,
			offset: parseInt(this.$route.query.offset) || 0,
			totalCount: 0
		}
	},

	// 이 컴포넌트에서 구현할 기능
	methods: {
		routerArticle: function(article) {
			const { offset, pageSize, keyword } = this;
			this.$router.push(`/board/${article.boardId}/detail/${article.articleId}${`?offset=${parseInt(offset)}`}${`&pageSize=${parseInt(pageSize)}`}${keyword && `&keyword=${keyword}` || ''}`);
		},
		routerMainArticle: function(article) {
			const { offset, pageSize, keyword } = this;
			this.$router.push(`/board/${article.boardId}/detail/${article.parentsId}${`?offset=${parseInt(offset)}`}${`&pageSize=${parseInt(pageSize)}`}${keyword && `&keyword=${keyword}` || ''}`);
		},
		routerBoardList: function() {
			this.$router.push('/board');
		},
		routerBoardModify: function() {
			const { selectedBoard } = this;
			this.$router.push(`/board/${selectedBoard.boardId}/modify`);
		},
		getBoardList: async function() {
			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.BOARD}`, { lecId: 0 });
				const { trashBoardId } = this;
				let { boardId } = this.$route.params;
				let trashBoardInfo = "";
				this.sideMenus = data.list.map(e => {
					const info = {
						board: e,
						selected: e.boardId === parseInt(boardId),
						name: e.boardName,
						hideEnable: e.hideEnable || 0,
						link: `/board/${e.boardId}`
					}
					if(!boardId) { // !! boardId = 0인 게시판은 없다. , 게시판 번호가 없을 때, 상단을 클릭
						this.selectedBoard = e;
						boardId = e.boardId;
						this.$router.push(`/board/${e.boardId}`);
					}
					if(e.boardId === parseInt(boardId)) { // selectedBoard 선택
						this.selectedBoard = e;
						this.link = `board.html?state=1&lecId=${e.lecId}&boardId=${e.boardId}`;
						this.moveLink =`/${server.hostParentName}/${this.link}`;
					}
					if(trashBoardId && trashBoardId === e.boardId) trashBoardInfo = info; // 휴지통 정보 저장
					return info;
				}).filter(e => parseInt(e.board.boardId) !== trashBoardId); // 휴지통 게시판 제외
				if(trashBoardId) this.sideMenus = [...this.sideMenus, trashBoardInfo]; // 휴지통 하단으로 내리기
			} catch(e) {e}
		},
		getArticlList: async function() {
			try {
				const { keyword, offset, pageSize } = this;
				const { boardId } = this.$route.params;
				if(!boardId) return;

				const { data } = await Axios.post(`${server.addr()}${server.api.ARTICLE}`, {
					boardId, pageSize, offset, keyword, orderBy:'reply_index DESC, a.reg_date'
				});
				data.list.map((e,idx) => { e.num = idx; e.noticeEnable = 0});
				
				const { data:noticeData } = await Axios.post(`${server.addr()}${server.api.ARTICLE}`, {
					boardId, noticeEnable:1, orderBy:'reply_index DESC, a.reg_date'
				});
				data.list = [...noticeData.list, ...data.list];

				this.articleList = data.list.map(e=>{ 
					e["selected"] = false;
					if(e.noticeEnable) {
						e["nameColor"] = "#f08300";
						e["backgroundColor"] = "#f8f8f8";
					}
					return e; 
				});

				this.totalCount = parseInt(data.filtered);
			} catch(e) {
				// TODO : error exception
			}
		},
		searchByKeyword: function(keyword) {
			const { pageSize } = this;
			this.offset = 0;
			this.keyword = keyword;
			this.$router.replace({ query: {offset: this.offset, pageSize, keyword} });
			this.getArticlList();
		},
		selectAll: function() {
			const targetBool = !this.articleList.reduce((prev, curr) => prev && curr.selected , true);
			this.articleList.forEach(art=>{
				art.selected = targetBool;
			});
		},
		onPageChanged: function(page) { // 페이지네이션 이벤트 핸들러
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;
			this.$router.replace({ query: {offset: this.offset, pageSize} });
			this.getArticlList();
		},
		deleteBoard: function() {
			this.modals.ModalConfirm.msg = "정말 게시판을 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "확인";
			this.modals.ModalConfirm.btnNo.name = "취소";
			this.modals.ModalConfirm.btnYes.fn = () => {
				const { boardId } = this.$route.params;
				Axios.delete(`${server.addr()}${server.api.BOARD}/${boardId}`).then(() => {
					this.modals.ModalConfirm.show = false;
					this.routerBoardList();
				});
			}
			this.modals.ModalConfirm.btnNo.fn = () => { this.modals.ModalConfirm.show = false; };
			this.modals.ModalConfirm.show = true;
		},
		showModalBoardManager: function(type, article){
			console.log(article);
			this.modals.ModalBoardManager.article = article;

			if(type === "trash"){
				const articleId = article.articleId
				this.onConfirm({
					message: "휴지동으로 이동 하시겠습니까?",
					yesCb: async () => {	
						if(!server.trashBoardId) return;
						await Axios.patch(`${server.addr()}${server.api.ARTICLE}/${articleId}`, {
							boardId : server.trashBoardId
						}).then(() => {
							this.$emit("onDone", "휴지통으로 이동 되었습니다.");
							this.$router.go();
						})
					},
				});
				return;
			}

			if(type === "move"){
				this.modals.ModalBoardManager.type = "이동";
			}else if(type === "copy"){
				this.modals.ModalBoardManager.type = "복사";
			}else{
				alert("오류 발생. 개발자 문의");
			}
			this.modals.ModalBoardManager.show = true;
		},
		deleteArticle: function(article) {
			this.modals.ModalConfirm.msg = "게시물을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = () => {
				const { articleId } = article;
				if(!articleId) return;
				Axios.delete(`${server.addr()}${server.api.ARTICLE}/${articleId}`).then(() => {
					this.modals.ModalConfirm.show = false;
					this.getArticlList();
				});
			};
			this.modals.ModalConfirm.show = true;			
		},
		deleteArticleList: async function() {
			try {
				const {modals} = this;
				const checkArticleList = this.articleList.filter(article => article.selected).map(article => {
					return {
						articleId: article.articleId
					}
				});
				if(!checkArticleList.length) {
					modals.ModalAlert.msg = "게시물을 선택해 주세요.";
					modals.ModalAlert.show = true;
					return;
				}
				await Axios.delete(`${server.addr()}${server.api.ARTICLE}`,{data:[...checkArticleList]});
				modals.ModalAlert.msg = "삭제 되었습니다.";
				modals.ModalAlert.show = true;
				this.getArticlList();
			} catch (error) {//
			}
		},
		trashArticleList: async function() {
			try {
				const {trashBoardId, modals} = this;
				if(!trashBoardId) return;
				const checkArticleList = this.articleList.filter(article => article.selected).map(article => {
					return {
						...article,
						boardId: this.trashBoardId
					}
				});
				if(!checkArticleList.length) {
					modals.ModalAlert.msg = "게시물을 선택해 주세요.";
					modals.ModalAlert.show = true;
					return;
				}
				await Axios.patch(`${server.addr()}${server.api.ARTICLE}`, [...checkArticleList]);
				modals.ModalAlert.msg = "이동 되었습니다.";
				modals.ModalAlert.show = true;
				this.getArticlList();
			} catch (error) {//
			}
		},
		excelDownload: function() {
			const {keyword, selectedBoard, startDate, endDate} = this;
			const boardId = selectedBoard.boardId;
			Axios.post(server.addr()+server.api.ARTICLE_EXCEL, {
				keyword,
				articleList:[{boardId}],
				startDate,
				endDate:  moment(new Date(endDate).setDate(new Date(endDate).getDate() + 1)).format("YYYY-MM-DD")
			}).then(response => {
				window.open(`${server.addr()}/download/${response.data}`,"", "");
			})
		},
	},
	computed: {
		allSelected: function() {
			if(!this.articleList.length) return;
			const isAllSelected = this.articleList.reduce((prev, curr) => prev && curr.selected , true);
			return isAllSelected;
		}
	}
}
</script>

<style scoped>
.recycle {
	fill: #fff;
	fill-rule: evenodd;
}

.btn-group .btn:hover .recycle {
	fill: #fff;
	fill-rule: evenodd;
}
</style>